/* eslint-disable react/jsx-filename-extension */

import { displayNotif } from 'hb-react/shared/helpers/notifications';
import copyToClipboard from 'hb-react/shared/utils/copyToClipboard';

import { getEventDedicatedUrl } from './getEventDedicatedUrl';

const getActionItems = ({
  currentUrl,
  currentUser,
  event,
  handleDeleteItem,
  handleEditItem,
  handleHideUser,
  handleReportContent,
  icons,
  networkConfig,
}) => {
  const itemDedicatedUrl = getEventDedicatedUrl({
    currentUrl,
    event,
    currentUser,
  });

  const copyLinkActionItem = itemDedicatedUrl
    ? {
        label: __('Copy link'),
        icon: icons.copyLink,
        onClick: () => {
          copyToClipboard(itemDedicatedUrl, () => {
            displayNotif('success', __('Link copied to clipboard'));
          });
        },
      }
    : null;

  // If currentUser if the owner
  const { user } = event;

  if (currentUser && user?.id === currentUser?.id) {
    const items = [];

    if (copyLinkActionItem) {
      items.push(copyLinkActionItem);
    }
    items.push(
      {
        label: __('Edit'),
        icon: icons.edit,
        onClick: handleEditItem,
      },
      {
        label: __('Delete'),
        icon: icons.delete,
        onClick: handleDeleteItem,
      },
    );

    return items;
  }

  // If content from another user
  if (currentUser && user) {
    const items = [];

    if (copyLinkActionItem) {
      items.push(copyLinkActionItem);
    }

    if (networkConfig?.user_can_report_user_contents) {
      items.push(
        {
          label: __('Report this content'),
          icon: icons.circleExclamation,
          onClick: handleReportContent,
        },
        {
          label: s__('BlockUser|Block user'),
          icon: icons.ban,
          onClick: handleHideUser,
        },
      );
    }

    if (items.length > 0) {
      return items;
    }
  }

  // Item from the network
  if (copyLinkActionItem) {
    return [copyLinkActionItem];
  }

  return null;
};

export default getActionItems;
